export const generateASCII = (
  width,
  height,
  frame,
  pattern,
  characterSet,
  characterCount,
  density,
  gamma,
  contrast,
  videoFrames = [],
  currentVideoFrame = 0
) => {
  let result = '';
  
  let allChars = [...characterSet];
  if (allChars.length === 0) {
    allChars = [' '];
  }
  
  const sortedChars = allChars.sort((a, b) => {
    const densityMap = {
      ' ': 0, '`': 1, '.': 2, "'": 3, ':': 4, ',': 5, ';': 6, 
      '-': 7, '~': 8, '"': 9, '_': 10, '+': 11, '=': 12, '<': 13, 
      '>': 14, 'i': 15, '!': 16, 'l': 17, 'I': 18, '?': 19, '/': 20, 
      '\\': 21, '|': 22, '(': 23, ')': 24, '1': 25, '{': 26, '}': 27, 
      '[': 28, ']': 29, 'r': 30, 'c': 31, 'v': 32, 'u': 33, 'n': 34, 
      'x': 35, 'z': 36, 'j': 37, 'f': 38, 't': 39, 'L': 40, 'C': 41, 
      'J': 42, 'U': 43, 'Y': 44, 'X': 45, 'Z': 46, 'O': 47, 'Q': 48, 
      '0': 49, '*': 50, '#': 51, 'M': 52, 'W': 53, '&': 54, '8': 55, 
      '%': 56, 'B': 57, '@': 58, '∙': 59, '·': 60, '˙': 61, '¨': 62,
      '○': 63, '◦': 64, '░': 65, '▒': 66, '▓': 67, '█': 68
    };
    
    const getDensity = (char) => {
      if (densityMap.hasOwnProperty(char)) {
        return densityMap[char];
      }
      const code = char.charCodeAt(0);
      return code % 69;
    };
    
    return getDensity(a) - getDensity(b);
  });
  
  const chars = sortedChars.slice(0, Math.max(2, Math.min(characterCount, sortedChars.length)));
  const numChars = chars.length;
  
  const imageData = videoFrames.length > 0 ? videoFrames[currentVideoFrame] : null;
  
  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const scaledX = (x / width) * 60;
      const scaledY = (y / height) * 35;
      
      let value;
      
      if (imageData) {
        const idx = (y * width + x) * 4;
        const r = imageData[idx] || 0;
        const g = imageData[idx + 1] || 0;
        const b = imageData[idx + 2] || 0;
        const brightness = (r + g + b) / (3 * 255);
        value = ((brightness - 0.5) * 2) * density;
      } else {
        try {
          value = pattern(scaledX, scaledY, frame, density);
          if (isNaN(value) || !isFinite(value)) {
            value = 0;
          }
        } catch (e) {
          value = 0;
        }
      }
      
      const sign = value >= 0 ? 1 : -1;
      value = sign * Math.pow(Math.abs(value), 1 / gamma);
      value = (value - 0.5) * contrast + 0.5;
      
      const normalized = Math.max(0, Math.min(1, (value + 1) / 2));
      const charIndex = Math.floor(normalized * (numChars - 1));
      const clampedIndex = Math.max(0, Math.min(numChars - 1, charIndex));
      
      const char = chars[clampedIndex];
      result += (char !== undefined ? char : ' ');
    }
    result += '\n';
  }
  
  return result;
};